// extracted by mini-css-extract-plugin
module.exports = {"product-cart-availability-wrapper":"product-cart-actions_product-cart-availability-wrapper___FaYM"};